import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useToastSeeker} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import { BACKEND_APIS } from "@constants";
import {commonFiltersValue, isLoadingCommonFilters} from "@signals";
import {isLoadingTable} from "../@signals";


export default function useUserActivityTable() {
	const { showToast } = useToastSeeker()
	const tableData = useSignal([])
	const isLoading = useSignal(false)

	useEffect(() => {
        isLoadingTable.value = isLoading.value;
    }, [isLoading.value]);

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			tableData.value = []
			isLoading.value = true
			postSubmit(`${BACKEND_APIS.ADMIN}/user-activities/details`, { ...commonFiltersValue.value }).then(({ data }) => batch(() => {
				if (!data?.length) {
					isLoadingCommonFilters.value = false
				} else {
					tableData.value = data
				}
			})).catch(() => showToast.error())
			.finally(() => isLoading.value = false)
		})
	}, [isLoadingCommonFilters.value]);

	return {
		tableData: tableData.value,
		isLoadingTable: isLoading.value
	}
}